import { useEffect, useState } from 'react';

import { BREAKPOINTS } from '@/common/constants';
import { NODES_DEPTH } from '@/ebat/constants';
import { useHeaderMenuContext } from '@/ebat/contexts/Header/HeaderMenuContext/HeaderMenuContext';

const MAX_PANEL_WIDTH = 343;
const MARGIN = 130;

const useMenuWidth = (displayedPanelCount) => {
  const [panelWidth, setPanelWidth] = useState(null);
  const { setWidth } = useHeaderMenuContext();

  useEffect(() => {
    const handleResize = () => {
      const { offsetWidth } = document.body;
      let width = null;
      if (offsetWidth >= BREAKPOINTS.desktop) {
        const totalWidth = offsetWidth - MARGIN;
        if (displayedPanelCount * MAX_PANEL_WIDTH < totalWidth) {
          width = MAX_PANEL_WIDTH;
        } else {
          width = Math.floor((offsetWidth - MARGIN) / NODES_DEPTH);
          if (width > MAX_PANEL_WIDTH) {
            width = MAX_PANEL_WIDTH;
          }
        }
      }

      setPanelWidth(width);
    };
    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [displayedPanelCount]);

  useEffect(() => {
    if (panelWidth !== null) {
      setWidth(panelWidth * displayedPanelCount);
    }
  }, [displayedPanelCount, panelWidth, setWidth]);

  return { panelWidth };
};

export default useMenuWidth;
